module.exports = __webpack_public_path__ + "static/CARE-639e6b5e528b711e03ccbe904975863e.jpg";